import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SetPasswordForm from "../../components/auth/SetPasswordForm";

export default function SetPassword() {
  return (
    <>
      <PageMeta
        title="Chargemont | Set Password"
        description="Chargemont | Set Password"
      />
      <AuthLayout>
        <SetPasswordForm />
      </AuthLayout>
    </>
  );
}
